import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6
import { Input } from 'antd';

const { TextArea } = Input;

const shaDeDeshabilitarElComponent = variable => {
    const { esPotEditar, esValorCalculAutomatic } = variable;
    const esNoEditable = (typeof (esPotEditar) === 'undefined') ? false : !esPotEditar;
    return esNoEditable || esValorCalculAutomatic;
};

class ObservacioIntroduccioVariableText extends Component {

    render() {
        const variable = this.props.variable;
        const valor = variable.hasOwnProperty('valorNou') ? variable.valorNou : variable.valor;

        return (
            <div className="observacio-introduccio-variable">
                <span>
                    {variable.nomVariable}
                    <TextArea
                        autosize={{ minRows: 2, maxRows: 1 }}
                        onChange={(event) => this.props.onChangeValorVariable(event.target.value)}
                        defaultValue={ valor }
                        disabled={shaDeDeshabilitarElComponent(variable)} />
                </span>
                {variable.unitats}
            </div>
        );
    }
}

ObservacioIntroduccioVariableText.propTypes = {
    variable: PropTypes.object,
    onChangeValorVariable: PropTypes.func
};

export default ObservacioIntroduccioVariableText;



// WEBPACK FOOTER //
// ./src/components/observacio/observacioIntroduccioVariableText.js